export const BRAND_NAME = 'No More Missed Calls';
export const BRAND_LOGO_SRC = '/logo.png';
